import { cva, type VariantProps } from 'class-variance-authority'
import { View } from 'react-native'
import { cn } from '~/lib/utils'

const dotVariants = cva('size-2 rounded-full', {
  variants: {
    variant: {
      primary: 'bg-accent',
      secondary: 'bg-secondary',
      warning: 'bg-warning',
      success: 'bg-success',
    },
  },
})

export type DotVariant = NonNullable<VariantProps<typeof dotVariants>['variant']>

export function Dot({
  className,
  variant = 'primary',
}: {
  className?: string
  variant?: DotVariant
}) {
  return <View className={cn(dotVariants({ variant }), className)} />
}
